// Badge.jsx
import { X } from 'lucide-react';
import React from 'react';

const FilterBadge = ({ label, value, onRemove }) => {
  const isHTML = typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value);

  return (
    <div className='docpro_filtered_badge'>
      <span>
        <b className='small_filter_block'>{label}:</b>{" "}
        {isHTML ? (
          <span style={{ padding: "0", border: 0 }} dangerouslySetInnerHTML={{ __html: value }} />
        ) : (
          value
        )}
      </span>
      <button
        onClick={onRemove}
      >
        <X width={20} height={20} />
      </button>
    </div>
  );
};

export default FilterBadge;
